import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';
import moment from 'moment';
import Chart from 'chart.js';

class ChartRequests extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            requests: props.requests,
            rangeDates: [],
            labels: [],
            datasets: [],
            chart: {},
        };
    }

    componentDidMount() {
        this.createRangeDates();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { requests } = nextProps;

        if (!requests.length) {
            return;
        }

        this.setState({
            requests,
        }, () => {
            this.createRangeDates();
        })
    }

    createLabels() {
        let { from, until } = this.props;

        let labels = [];
        let currentDate = moment(from);
        let untilMoment = moment(until);

        while (currentDate <= untilMoment) {
            labels.push( moment(currentDate).startOf('day').format('DD.MM.YYYY') );
            currentDate = moment(currentDate).add(1, 'days');
        }

        return labels;
    }

    createRangeDates() {
        let { requests, chart } = this.state;

        const labels = this.createLabels();
        const values = [];

        labels.forEach((item) => {
            let count = 0;
            requests.forEach((gazetter) => {
                if (item === moment(gazetter.date).utc().startOf('day').format('DD.MM.YYYY')) {
                    count++;
                }
            });

            values.push(count);
        });

        const datasets = [{
            label: 'Requests',
            backgroundColor: 'green',
            borderColor: 'green',
            stack: 'Stack 0',
            data: values,
        }];

        if (_.isEmpty(chart)) {
            chart = this.createChart(labels, datasets);
        } else {
            chart = this.updateChart(chart, labels, datasets);
        }

        this.setState({
            labels,
            datasets,
            chart,
        });
    }

    updateChart(chart, labels, datasets) {
        chart.data.labels = labels;
        chart.data.datasets = datasets;

        chart.update(0);

        return chart;
    }

    createChart(labels, datasets) {
        const ctx = this.refs.chartRequests.getContext('2d');
        const chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets,
            },
            options: {
                tooltips: {
                    mode: 'label'
                },
                scales: {
                    xAxes: [{
                        stacked: true
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            }
        });

        return chart;
    }

    render() {
        return (
            <div className='row'>
                <div className='col-xs-12'>
                    <canvas ref='chartRequests' />
                </div>
            </div>
        );
    }
}

export default connect(
    (state, { requests }) => {
        return {
            requests,
        };
    },
    dispatch => bindActionCreators({}, dispatch),
)(ChartRequests);



// WEBPACK FOOTER //
// ./app/components/Statistics/St/Charts/Requests.jsx